export default __webpack_public_path__ + "8579c68cc624e6227a9f6f711a3bbec6.svg";